function goToUrl(url) {
  document.body.style.cursor = 'wait';
  window.location.href = url;
}

function goToQuiz() {
  goToUrl('/quizzes/');
}

const locationService = {
  goToUrl,
  goToQuiz,
};

export default locationService;
